import { InventoryOutputDetailPrintModel } from "./inventory-output-detail-print.model";

export class InventoryOutputPrintModel {
  inventoryOutputId: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  branchCode: string = "";
  branchName: string = "";
  address: string = "";
  phone: string = "";
  inventoryId: number = 0;
  inventoryCode: string = "";
  inventoryName: string = "";
  consecutive: string = "";
  dateOutput: Date = new Date();
  clientId: number = 0;
  clientNit: string = "";
  clientName: string = "";
  observation: string | null = null;
  userAuthenticated: string = "";
  inventoryOutputDetails: InventoryOutputDetailPrintModel[] = [];
}